import * as React from "react";
import { Route } from "react-router-dom";

import FullscreenWidgets from "./FullscreenWidgets";

const FullscreenWidgetsRouter: React.FC = () => (
  <Route path={["/apps/:slugOrId", "/"]}>
    {/* @ts-expect-error TS(2339): Property 'slugOrId' does not exist on type '{} | {... Remove this comment to see the full error message */}
    {({ match }) => <FullscreenWidgets visibleWidgetSlugOrId={match ? match.params.slugOrId : null} />}
  </Route>
);

export default FullscreenWidgetsRouter;
